import VueLib from 'vue'
import * as Sentry from '@sentry/browser'
import { Dedupe, ExtraErrorData, ReportingObserver, RewriteFrames, Vue } from '@sentry/integrations'

export default function (ctx, inject) {
  const opts = Object.assign({}, {"dsn":"https:\u002F\u002Fee83ff2c9cb64a2594f4f23440a2c656@frontmon-sysop.bigo.sg\u002F6","environment":"production","disabled":false,"sampleRate":0.5,"tagMap":{"actName":"act.name","actDeveloper":"act.developer"},"tags":{"act.name":"www.bigo.tv.ssr","act.developer":"chenwanqun,masongzhi"}}, {
    integrations: [
      new Dedupe({}),
      new ExtraErrorData({}),
      new ReportingObserver({}),
      new RewriteFrames({}),
      new Vue({Vue: VueLib, ...{"attachProps":true}})
    ]
  })

  // Initialize sentry
  Sentry.init(opts)

  // Inject Sentry to the context as $sentry
  inject('sentry', Sentry)
  ctx.$sentry = Sentry
}
